var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0a16 16 0 100 32 16 16 0 000-32zm9 12.11L15.11 22a1.51 1.51 0 01-1.06.44h-.15a1.51 1.51 0 01-1.06-.44l-5.3-5.3a1.5 1.5 0 112.12-2.12L14 18.9l8.89-8.9A1.5 1.5 0 1125 12.11z"
  })));
}

export default SvgSuccess;